export const adminPageBg = "min-h-screen bg-[#f3f3f3]";
export const adminPageTitle = "text-2xl md:text-[26px] font-black text-gray-900 tracking-tight uppercase italic min-w-0";
export const adminSearchWrap = "relative w-full sm:w-auto sm:max-w-xs sm:min-w-[240px]";
export const adminSearchInput = "w-full h-9 rounded-lg border border-gray-300 bg-white pl-9 pr-3 text-xs text-gray-700";
export const adminCard = "rounded-xl border border-gray-200 bg-white p-4 md:p-6";
export const adminTabBase = "pb-2 text-sm";
export const adminTabActive = "text-gray-900 border-b-2 border-red-600";
export const adminTabIdle = "text-gray-500";
export const adminTableWrap = "rounded-lg border border-gray-200 overflow-x-auto custom-scrollbar";
export const adminTableHead = "bg-black text-white text-sm";
export const adminTh = "px-4 py-3";
export const adminRow = "border-t border-gray-100 text-sm";
export const adminTdName = "px-4 py-4 font-medium text-gray-900";
export const adminTd = "px-4 py-4 text-gray-600";
export const adminEmpty = "px-4 py-12 text-center text-sm text-gray-400";
export const adminPrimaryBtn =
  "inline-flex items-center justify-center rounded-lg bg-[#8b0000] px-4 py-1.5 text-xs font-semibold text-white hover:bg-[#6f0000]";
export const adminSecondaryBtn =
  "inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50";
export const adminDangerBtn =
  "inline-flex items-center justify-center rounded-lg border border-red-200 px-4 py-1.5 text-xs font-semibold text-[#8b0000] hover:bg-red-50";
export const adminStatusPill = "inline-flex rounded-full px-3 py-1 text-xs font-semibold";
